import { render, staticRenderFns } from "./SlglrsNP_OverviewPage.vue?vue&type=template&id=3d98c467&"
import script from "./SlglrsNP_OverviewPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsNP_OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SlglrsNP_OverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports